import moment from 'moment';
import 'moment-timezone';
import store from '../../stores/redux';
import UserStore from '../../stores/UserStore';
import {
    countries
} from './config';

const TZ = {
    getCountries() {
        const staticNamesCountries = UserStore.getTranslation().countries;
        let list = [];

        countries.map((country) => {
            list.push({
                ...country,
                name: staticNamesCountries[country.country_code]
            });
        });

        list.sort((a, b) => {
            if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
            return 0;
        });

        return list;
    },

    getCurrentCountry() {
        const staticNamesCountries = UserStore.getTranslation().countries;
        const timezone = store.getState().user.timezone;
        let data = {};

        countries.find((country) => {
            if (country.timezones.indexOf(timezone) !== -1) {
                data = {
                    ...country,
                    name: staticNamesCountries[country.country_code]
                };

                return true;
            }

            return false;
        });

        return data;
    },

    getCurrent() {
        return store.getState().user.timezone;
    },


    getTimezone(key) {
        const staticNamesTimezones = UserStore.getTranslation().timezones;
        const utc = moment.tz(new Date(), key).format("Z");

        return {
            key,
            utc,
            name: staticNamesTimezones[key],
            nameLong: `(UTC ${utc}) ${staticNamesTimezones[key]}`
        };
    },

    /**
     * The reports and the conversions API accept only timezones with a whole-hour UTC offset
     * (control: AppBundle\Service\Reporting\Parameters::_setTimezone, "Incorrect timezone");
     * e.g. Asia/Colombo (+05:30) or Asia/Kathmandu (+05:45) are not supported.
     */
    isWholeHourOffset(key) {
        if (!key || !moment.tz.zone(key)) {
            return false;
        }

        return moment.tz(new Date(), key).utcOffset() % 60 === 0;
    },

    /**
     * A timezone the API accepts: the given one, otherwise the user's one, otherwise UTC.
     */
    toSupportedTimezone(key) {
        if (this.isWholeHourOffset(key)) {
            return key;
        }
        const userTimezone = UserStore.getValidTimeZone();

        return this.isWholeHourOffset(userTimezone) ? userTimezone : 'UTC';
    },

    // timezones for the filters: only the ones the API accepts (see isWholeHourOffset)
    getAllTimezones() {
        const staticNamesTimezones = UserStore.getTranslation().timezones;
        const res = Object.entries(staticNamesTimezones)
            .filter(([key]) => this.isWholeHourOffset(key))
            .map(([key, name]) => {
                const utc = moment.tz(new Date(), key).format("Z");
                const utcShift = parseInt(moment.tz(new Date(), key).format("ZZ"), 10) / 100;

                return {
                    key,
                    utc,
                    utcShift,
                    name,
                    nameLong: `(UTC ${utc} ${key}) ${name}`,
                };
            })
            .sort((a, b) => a.utcShift - b.utcShift);

        return res;
    },
};

export default TZ;
